export default "__VITE_ASSET__COlOr5NI__"